

import '../../Common/css/Search.css';
import React, {Component, useEffect, useState} from 'react';
import Text from '../../../common/Text.js';
//import { forwardRef, useEffect, useImperativeHandle, useRef } from "react"

export const Example = (getSearchList) => {
  
  const [inputText, setInputText] = useState("");
  const [SelectValue, setSelectValue] = useState("제목");
  
    const activeButton = () => {  getSearchList.getSearchList(inputText, SelectValue);  }

    const activeEnter = (e) => {
      if(e.key === "Enter") {
        activeButton();
      }
    }

      
      
    return (
              <div className = 'search'>
  
                  <select className="typeS"  onChange={(e) => setSelectValue(e.target.value)}>
                        <option>제목</option>
                        <option>내용</option>
                        <option>제목+내용</option>
                  </select>


 
                  <div class="inputBrd">
                      <input  class="inputd" 
                              value={inputText}
                              onChange={(e) => setInputText(e.target.value)}
                              onKeyDown={(e) => activeEnter(e)}>
                      </input>
                  </div>
                  
                  <button className = 'Searchbtn' onClick={activeButton}> 
            <Text variant="px18" >
                    <div >검색</div>
            </Text></button> 

              </div>

                  )
}

export default Example;